define('uikit/modules/dimmer',['require','exports','module','underscore','backbone','marionette','../mixins/component.mixin','templates','../channel','../definitions/modules/dimmer'],function(require, exports, module){
  var _              = require('underscore');
  var Backbone       = require('backbone');
  var Mn             = require('marionette');
  var ComponentMixin = require('../mixins/component.mixin');
  var Templates      = require('templates');
  var channel        = require('../channel');
  var test           = require('../definitions/modules/dimmer');

  var Dimmer = Mn.ItemView.extend(ComponentMixin).extend({

    className: 'ui dimmer',

    template: Templates.App['dimmer'],

    options: {
      active   : false,
      centered : false,
      page     : false,
      disabled : false,
      inverted : false
    },

    forceUpdate: { centered: true },

    bindings: {
      // active  : 'active',
      // content : 'text'
    },
    
    _showDimmer: function() {
      if (!this._isShown) { return; }
      this.$el.dimmer({
        closable: false
      })
      .dimmer('show');
    },

    _hideDimmer: function() {
      if (!this._isShown) { return; }
      this.$el.dimmer('hide');
    },

    onFirstRender: function() {
      if (this._isShown) {
        this._initialEvents();
      } else {
        this.once('show', function() {
          this._initialEvents();
        }, this);
      }
    },

    _initialEvents: function() {
      this.on("change:active", _.debounce(function() {
        if (this.active) {
          this._showDimmer();
        } else {
          this._hideDimmer();
        }
      }, 1));

      if (this.active) {
        this._showDimmer();
      }
    },

    updateAttributes: function() {
      this
          .addClass('page', this.getBoolOption('page'))
          .addClass('disabled', this.getBoolOption('disabled'))
          .addClass('inverted', this.getBoolOption('inverted'));
    }


  });

  channel.reply('dimmer', function() {
    return Dimmer;
  });

  module.exports = Dimmer;
});
